import React from "react";

export function ConflictConfirmationText() {
    return (
        <div>
            <div>
                Документ открыт в другой вкладке браузера или на другом компьютере. Одновременная работа с черновиком
                одного документа недопустима.
            </div>
            <br />
            <div>Обновите страницу или закройте ее, продолжив работать в другой вкладке.</div>
        </div>
    );
}
